import { Actions } from './actions.js';
const actionProps = {
    onKeyphraseChanged: Actions.KEYPHRASE_CHANGED,
};
export default actionProps;
